<template>
<div class="dashboard-panel">
    <portal target-el="#filter">
      <PrimaryFilter
        :menuOptions="menuList"
        :selectedCategory="selectedCategory"
        :enableSearchPopup="enableSearchPopup"
        :searchParameters="searchConstants"
        :preSearchedParams="searchedParams"
        :searchText="$t('MDM_SEARCH')"
        :buttonsList="filterButtons"
        @export="exportLogs"
        @searchByParameter="searchByParameter" />
      </portal>

    <head-panel
      :isLisLoadingCompleted="isListLoadingCompleted"
      :integrationEvent="integrationEvent"
      :depotFilterEnabled= "false"
      @filter-change="filterChange"
       />
    <EntityList
      :data="getCategorizedList"
      :isListLoadingCompleted="isListLoadingCompleted"
      @load-more="loadData"
      @select-item="selectItem"/>
    <EntityDetails
      :columnName = "integrationColumn"
      :columnType = "integrationType"
      :selectedEntity="selectedEntity"
    />
</div>
</template>

<script>
import moment from 'moment';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import { menuList, searchConstants} from '@/constants/integrations';
import EntityList from './entityList';
import EntityDetails from './entityDetails';
import HeadPanel from '@common/components/HeadPanel';
import { interfaceEventType } from 'pando-constants'


export default {
  components: {
    HeadPanel,
    EntityList,
    EntityDetails,
    PrimaryFilter,
  },

  data() {
    return {
      searchedParams: {},
      integrationList: [],
      category: null,
      entityDetails: null,
      searchConstants,
      menuList,
      integrationType: 1,
      enableSearchPopup: true,
      isListLoadingCompleted: true,
      integrationEvent: true,
      integrationDates: '',
      integrationColumn: '',
      emptyData: false,
      selectedEntity: {},
      interfaceEventType,
      isExporting: false,
    };
  },
  computed: {
    filterButtons() {
      return [
        {
          id: 'export',
          name: 'Export',
          show: this.$hasPermission('export_integration_logs'),
          class: 'btn-primary',
          emitMethod: 'export',
        },
      ];
    },
    getCategorizedList() {
      return this.integrationList.map(integration => {
        // Grouped format (append mode enabled on backend)
        if (integration.trigger_count) {
          return {
            ...integration.latest,
            trigger_count: integration.trigger_count,
            history: integration.history,
          };
        }
        // Flat format (legacy — flag disabled)
        return {
          ...integration,
          updatedAt: moment(integration.updated_at).format('MMM Do YYYY  - hh:mm A'),
        };
      });
    },
    selectedCategory(){
      const path = this.$router.history.current.name;
      return this.menuList.find(menu=> menu.id === path);
    },
  },
  created() {
    this.loadSearchFromSession();
  },
  methods: {
    async filterChange({ type, category, dates, columnMap }) {
      this.integrationType = type;
      this.category = category;
      this.integrationDates = dates;
      this.integrationColumn = columnMap;
      this.page = 1;
      this.emptyData = false;
      this.integrationList = [];
      this.entityDetails = null;
      this.selectedEntity = {};
      await this.loadData();
    },
    loadSearchFromSession() {
      const sessionSearchParamsJSON = localStorage.getItem(`${this.$route.name}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = Object.assign({}, this.searchedParams, sessionSearchParams);
    },
    saveSearchToSession() {
      const sessionSearch = JSON.stringify(this.searchedParams);
      localStorage.setItem(`${this.$route.name}-search-popup`, sessionSearch);
    },
    async searchByParameter(params) {
      this.searchedParams = params;
      this.saveSearchToSession();
      this.page = 1;
      this.emptyData = false;
      this.integrationList = [];
      await this.loadData();
    },
    async loadData() {
      this.isListLoadingCompleted = false;
      if (!this.emptyData) {
        const params = {};
        let dateObj = null;
        if (this.searchedParams && Object.keys(this.searchedParams).length) {
          Object.assign(params, { ...this.searchedParams });
        }
        if (
          this.integrationDates &&
          this.integrationDates.length &&
          this.integrationDates.length === 2
        ) {
          dateObj = {
            start_date: this.integrationDates[0],
            end_date: this.integrationDates[1],
          };
        }
        let result = [];
        result = await this.$store.dispatch(
          'order/getIntegrationData',
          {
            page: this.page,
            type: this.interfaceEventType.INTEGRATION,
            category: this.category,
            dateObj,
            params,
          },
        );

        if (result.length !== 0) {
          this.integrationList = [...this.integrationList, ...result];
          this.page += 1;
          this.emptyData = false;
        } else {
          this.emptyData = true;
          this.entityDetails = null;
        }
      }
      this.isListLoadingCompleted = true;
    },
    async selectItem(entity) {
      this.selectedEntity = entity;
    },
    async exportLogs() {
      this.isExporting = true;
      const params = { ...this.searchedParams };
      let dateObj = null;
      if (this.integrationDates && this.integrationDates.length === 2) {
        dateObj = { start_date: this.integrationDates[0], end_date: this.integrationDates[1] };
      }
      const result = await this.$store.dispatch('order/exportIntegrationLogs', {
        type: this.interfaceEventType.INTEGRATION,
        category: this.category,
        dateObj,
        params,
      });
      if (result && result.error) {
        this.$error({ message: 'No integration logs found for the given filters.' });
      } else if (result === 'EXPORT_VIA_EMAIL') {
        this.$successMessage({ message: 'Large export — file will be sent to your email.' });
      }
      this.isExporting = false;
    },
  },
};
</script>
